const OPTICAL_SIZE_BASE_URL = 'https://fonts.gstatic.com/s/i/short-term/release/materialsymbols';
const getOpticalSize = (size) => size <= 22 ? 20 : size <= 32 ? 24 : size <= 44 ? 40 : 48;
const iconObserver = typeof ResizeObserver === 'function'
  ? new ResizeObserver(entries => entries.forEach(entry => entry.target.updateOpticalSize(entry.contentRect.width)))
  : null;
class ThemeIcon extends HTMLElement {
  #currentOpticalSize;
  connectedCallback() {
    this.#currentOpticalSize = Number(this.dataset.iconOpticalSize) || 24;
    iconObserver?.observe(this);
  }
  disconnectedCallback() { iconObserver?.unobserve(this); }
  updateOpticalSize(displaySize) {
    if (!displaySize) return;
    const size = getOpticalSize(displaySize);
    if (size === this.#currentOpticalSize) return;
    const { iconStyle, iconName, iconVariant } = this.dataset;
    if (!iconStyle || !iconName || !iconVariant) return;
    this.#currentOpticalSize = size;
    const url = `${OPTICAL_SIZE_BASE_URL}${iconStyle}/${iconName}/${iconVariant}/${size}px.svg`;
    this.style.setProperty('--icon-url', `url('${url}')`);
  }
}
if (!customElements.get('theme-icon')) customElements.define('theme-icon', ThemeIcon);
